
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IBarrier} from "@/interfaces/barrier.interface";
  import {barrierResource} from "@/resources/barrier.resource";
  import {IApp} from "@/interfaces/app.interface";
  import GateEventsLogFilters from "@/modules/barriers/components/EventsLog/GateEventsLogFilters.vue";
  import {IGateEventsLog} from "@/modules/barriers/interfaces/gate-events-log.interface";
  import {isMobile} from "mobile-device-detect";
  import {bus} from "@/plugins/bus";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import {IAppState} from "@/interfaces/app-state.interface";
  import _ from "lodash";

  @Component({
    components: {
      GateEventsLogFilters,
      AppDialog,
    },
  })
  export default class BarrierLogPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'barriers', dialogName: 'barrierLog' };
    command = IBarrier.Commands;
    activeTable = IBarrier.Commands.HistoryLog;
    loadingTableData = false;
    tableData: any[] = [];
    activeTab = IBarrier.Commands.HistoryLog;
    filters = null;

    tableSwitchers = [
      { label: 'Общий', command: IBarrier.Commands.HistoryLog },
      { label: 'Табло', command: IBarrier.Commands.TabloLog },
      { label: 'ШБ авто', command: IBarrier.Commands.GateLog },
      { label: 'ШБ кнопкой', command: IBarrier.Commands.GateEventsLog },
    ];

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get carPopupDisplay() { return this.storeState.car.displayPopup; }
    get tableProps() { return this.tableConfig[this.activeTable].props; }
    get tableConfig() {
      return {
        [IBarrier.Commands.HistoryLog]: {
          tableName: 'historyLog',
          props: [
            { prop: 'carnumber', label: 'Машина', action: this.openCarPopup },
            { prop: 'corpName', label: 'Корпорация', },
            { prop: 'dateCamMin', label: 'Дата', },
            { prop: 'sec', label: 'Сек.<br>назад', hideRule: isMobile, class: 'number', },
            { prop: 'readCnt', label: 'Камера<br>счит. раз', hideRule: isMobile, class: 'number', },
            {
              prop: 'gate',
              label: isMobile ? 'ШБ' : 'ШБ<br>через сек.',
              class: 'number',
              calculateClass: (tableItem) => !!tableItem.gate ? '' : 'bg--red-light',
            },
            { prop: 'GateOpenCnt', label: 'Кол-во открытий', hideRule: isMobile, class: 'number', },
            { prop: 'tablo', label: 'Табло<br>через сек.', hideRule: isMobile, class: 'number', },
            {
              prop: 'tabText',
              label: 'Табло',
              calculateClass: (tableItem) => !!tableItem.tabText ? '' : 'bg--red-light',
            },
            {
              prop: 'actions',
              label: isMobile ? '' : 'Действия',
              actions: [
                { title: 'Просмотр фото', icon: 'camera', action: (item, index) => this.openMediaPopup(item, index), },
              ],
            },
          ],
        },
        [IBarrier.Commands.TabloLog]: {
          tableName: 'tabloLog',
          props: [
            { prop: 'carnumber', label: 'Машина', action: this.openCarPopup },
            { prop: 'corpName', label: 'Корпорация', },
            { prop: 'tabloDate', label: 'Дата', },
            { prop: 'tabloMsgText', label: 'Табло', },
            { prop: 'sec', label: 'Сек. назад', class: 'number', },
          ],
        },
        [IBarrier.Commands.GateLog]: {
          tableName: 'gateLog',
          props: [
            { prop: 'carnumber', label: 'Машина', action: this.openCarPopup },
            { prop: 'corpName', label: 'Корпорация', },
            { prop: 'dateGateOpenMin', label: isMobile ? 'От' : 'Мин. дата открытия', },
            { prop: 'dateGateOpenMax', label: isMobile ? 'До' : 'Макс дата открытия', },
            { prop: 'gateOpenCnt', label: isMobile ? 'Кол-во' : 'Кл-во открытий', class: 'number', },
            { prop: 'sec', label: 'Сек. назад', class: 'number', },
          ],
        },
        [IBarrier.Commands.GateEventsLog]: {
          tableName: 'gateEventsLog',
          props: [
            { prop: 'dateEvent', label: 'Дата', },
            { prop: 'corpName', label: 'Корпорация', },
            { prop: 'persName', label: 'Пользователь', },
            { prop: 'eventName', label: 'Событие', },
          ],
        },
      };
    }

    async mounted() {
      setTimeout(() => {
        this.getTableData(IBarrier.Commands.HistoryLog);

        bus.$on(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.BarriersLogHistory,
          async ({ indexRow, direction }) => {
            let index = indexRow;
            if (direction === +1) index = indexRow === this.tableData.length - 1 ? 0 : indexRow + direction;
            else index = indexRow === 0 ? this.tableData.length - 1 : indexRow + direction;
            await this.openMediaPopup(this.tableData[index], index);
          }
        );
      }, 0);
    }

    async openMediaPopup(item, index: number) {
      const resourcePayload: ICamsPhoto.IPayloadCams = {
        camId: this.payloadPopup.cameraId,
        carNumber: item.original.carnumber,
        dateEvent: item.original.dateCamMin,
      };
      const { response } = await ICamsPhoto.GetCamsPhoto(resourcePayload);
      const mediaPayload: IAppMediaPopup.IPayload = {
        files: response && response.length ? response : [],
        fileErrorText: !item.carnumber ? 'Не было фиксации на данный период' : '',
        parentList: {
          name: IAppMediaPopup.MediaPopupSourceCall.BarriersLogHistory,
          currentIndex: index,
          total: this.tableData.length,
        },
        mediaInfo: {
          carNumber: item.carnumber,
          props: [
            { cells: [
                { label: 'Дата: ', value: item.dateCamMin.trim().replace('<br>', ' ') },
              ]
            },
          ],
        }
      };
      if (_.isEqual(this.storeState.dialog.activePopup, this.currentPopup)) {
        await this.$store.dispatch('dialog/openDialog', {
          blockName: 'allPages',
          dialogName: 'appMediaPopup',
          payload: {
            ...mediaPayload,
          },
        });
      }
      else {
        this.$store.commit('dialog/updateActivePopupPayload', mediaPayload);
        await this.$store.dispatch('dialog/reloadPopup');
      }
    }

    async openCarPopup(tableItem) {
      let locItem = {...tableItem};
      let payload: ICarStore.IPopupPayload = {};

      if (+locItem.carId > 0 || +locItem.carId < 0) payload.carId = locItem.carId;
      else return;

      await this.$store.dispatch('car/openCarPopup', payload);
    }

    async getTableData(command: IBarrier.Commands, filters?: IGateEventsLog.IFilters) {
      if (this.loadingTableData) return;
      this.activeTable = command;
      if (filters) this.filters = {...filters};

      this.loadingTableData = true;
      let asyncAction = async () => {
        let params: any = { command, cameraId: this.payloadPopup.cameraId, };
        if (this.filters) params = {...params, ...this.filters};
        const {data: {result: result }} = await barrierResource.httpAction({ params });
        this.tableData = result[this.tableConfig[command].tableName].map(item => {
          let result = {original: {...item}, ...item};
          const dateProps = ['dateCamMin', 'dateEvent', 'tabloDate', 'dateGateOpenMax', 'dateGateOpenMin',];
          dateProps.forEach((dateProp) => {
            if (item[dateProp])
              result[dateProp] = `
                ${this.$options.filters.moment(item[dateProp], isMobile ? IApp.DateFormats.PrintedDateShort : IApp.DateFormats.PrintedDateShortYear)}
                ${['dateGateOpenMin', 'dateGateOpenMax'].includes(dateProp) ? ' ' : '<br>'}
                ${this.$options.filters.moment(item[dateProp], isMobile ? IApp.DateFormats.PrintedTime : IApp.DateFormats.TimeFull)}
              `;
          });
          let numberProps = ['sec', 'gateOpenCnt',];
          numberProps.forEach(prop => {
            if (item[prop])
              result[prop] = `${this.$options.filters.currency(item[prop], '')}`;
          });

          if (isMobile) {
            const tabloProps = ['tabText', 'tabloMsgText'];
            tabloProps.forEach((prop) => {
              if (result[prop]) {
                result[prop] = `<b>Табло:</b> ${result[prop].replace('<br><br>', '<br>')}`;
              }
            })
          }

          return result;
        });
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
      this.loadingTableData = false;
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

    async reloadGateScreen() {
      let asyncAction = async () => {
        const params: any = { command: IBarrier.Commands.TabloReload, cameraId: this.payloadPopup.cameraId, };
        await barrierResource.httpAction({ params });
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
      await this.getTableData(this.activeTable);
    }

    destroyed() {
      bus.$off(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.BarriersLogHistory);
    }
  }
